/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import PageHero from '../containers/Pages/PageHero';
import ContactPage from '../containers/Pages/ContactPage';
import HomeFooter from '../containers/Home/HomeFooter';

const Contact = () => (
  <div>
    <PageHero
      meta={['Vol. 05 — Get in Touch', 'Management · Booking · Press']}
      eyebrow="Contact"
      title="Empezamos"
      italic="una conversación."
      lede="Management, booking, prensa y demos. Elige el departamento indicado — cuanto más específico, más rápido respondemos."
    />
    <ContactPage />
    <HomeFooter />
  </div>
);

export default Contact;
